/** @file Structural shape of a sector table; the table rules are checked by validateSectorTable. */
import { checkArray } from '@zilo/pose3d-format/validate/fields/checkArray';
import { checkBoolean } from '@zilo/pose3d-format/validate/fields/checkBoolean';
import { checkEnum } from '@zilo/pose3d-format/validate/fields/checkEnum';
import { checkNumber } from '@zilo/pose3d-format/validate/fields/checkNumber';
import { checkString } from '@zilo/pose3d-format/validate/fields/checkString';
import type { Shape } from '@zilo/pose3d-format/validate/fields/fieldCheck';
import { NAME_PATTERN } from '@zilo/pose3d-format/validate/fields/namePattern';

/** Shape of `SectorTable`. */
export const SECTOR_TABLE_SHAPE: Shape = {
  required: {
    id: checkString(NAME_PATTERN),
    thresholds: checkArray(checkNumber({ min: 0, max: 360 }), 1),
    tile: checkArray(checkNumber({ int: true, min: -1 }), 1),
    flip: checkArray(checkBoolean, 1),
    sideBack: checkArray(checkEnum([0, 1, 2]), 1),
  },
};
